function NotFound() {
  return (
    <div>
      Subpage not found!
    </div>
  );
}

export default NotFound;